import { render, staticRenderFns } from "./heatmaps.vue?vue&type=template&id=36d40c28"
import script from "./heatmaps.vue?vue&type=script&lang=js"
export * from "./heatmaps.vue?vue&type=script&lang=js"
import style0 from "./heatmaps.vue?vue&type=style&index=0&id=36d40c28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports